import { render, staticRenderFns } from "./prompt-dialog.vue?vue&type=template&id=4ae6a277"
import script from "./prompt-dialog.vue?vue&type=script&lang=js"
export * from "./prompt-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports